import { render, staticRenderFns } from "./FormAccessResponse.vue?vue&type=template&id=53167d4e&lang=pug"
import script from "./FormAccessResponse.vue?vue&type=script&lang=js"
export * from "./FormAccessResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53167d4e')) {
      api.createRecord('53167d4e', component.options)
    } else {
      api.reload('53167d4e', component.options)
    }
    module.hot.accept("./FormAccessResponse.vue?vue&type=template&id=53167d4e&lang=pug", function () {
      api.rerender('53167d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAccessResponse.vue"
export default component.exports